export default __webpack_public_path__ + "static/media/about-us-section-1.0f14cde8.png";